export default "__VITE_ASSET__Byyi8ge$__"